import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInternalService } from 'src/app/data/service/http.service';
import { AnalyticsService } from 'src/app/core/service/analytics/analytics.service';

// SD-1137: Email-capture sub-step. Offers three parallel paths — Chrome extension,
// Outlook add-in, forwarding address — rather than funnelling everyone to a single
// copy-paste. Install URLs / logos are read from the integrations DB table via
// Account/GetCaptureAddOns so URL changes don't need a release.
interface AddOnRecord {
  name: string;
  appURL: string;
  logoURL: string;
  shortDesc?: string;
}

@Component({
  selector: 'app-capture-email-setup',
  templateUrl: './capture-email-setup.component.html',
  styleUrls: ['./capture-email-setup.component.scss']
})
export class CaptureEmailSetupComponent implements OnInit {
  gmailAddOn: AddOnRecord | null = null;
  outlookAddOn: AddOnRecord | null = null;
  forwardingEmail = '';
  loading = true;
  copied = false;

  // Track which actions the user took before continuing, for analytics.
  private actionsTaken: string[] = [];

  constructor(
    private http: HttpInternalService,
    private router: Router,
    private analytics: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.analytics.capture('capture_email_substep_viewed');
    const orgId = localStorage.getItem('SelectedOrganization');
    this.http.getRequest<any>('Account/GetCaptureAddOns', { organizationId: orgId })
      .subscribe(
        (res) => {
          const addOns: AddOnRecord[] = res?.data?.addOns || [];
          this.gmailAddOn   = addOns.find(a => /gmail/i.test(a.name)) || null;
          this.outlookAddOn = addOns.find(a => /outlook/i.test(a.name)) || null;
          this.forwardingEmail = res?.data?.forwardingEmail || '';
          this.loading = false;
        },
        () => { this.loading = false; }
      );
  }

  installGmail(): void {
    if (!this.gmailAddOn?.appURL) return;
    this.actionsTaken.push('chrome_install_clicked');
    this.analytics.capture('capture_tool_install_started', { tool: 'chrome_extension' });
    window.open(this.gmailAddOn.appURL, '_blank', 'noopener');
  }

  installOutlook(): void {
    if (!this.outlookAddOn?.appURL) return;
    this.actionsTaken.push('outlook_install_clicked');
    this.analytics.capture('capture_tool_install_started', { tool: 'outlook_addin' });
    window.open(this.outlookAddOn.appURL, '_blank', 'noopener');
  }

  copyForwardingEmail(): void {
    if (!this.forwardingEmail) return;
    navigator.clipboard?.writeText(this.forwardingEmail).then(() => {
      this.copied = true;
      this.actionsTaken.push('forwarding_copied');
      this.analytics.capture('forwarding_address_copied');
      setTimeout(() => this.copied = false, 2000);
    });
  }

  continue(): void {
    this.analytics.capture('capture_email_substep_completed', {
      actions_taken: [...new Set(this.actionsTaken)]
    });
    const orgId = localStorage.getItem('SelectedOrganization');
    this.router.navigate(['/dashboard'], {
      queryParams: { OrganisationId: orgId, Domain: 'None' }
    });
  }

  skip(): void {
    this.analytics.capture('capture_email_substep_skipped');
    const orgId = localStorage.getItem('SelectedOrganization');
    this.router.navigate(['/dashboard'], {
      queryParams: { OrganisationId: orgId, Domain: 'None' }
    });
  }
}
